(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coins-sold"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-mint-coin-rain')) {
    customElements.define('mini-mint-coin-rain', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('.coins-sold__motion');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.small = matchMedia('(max-width: 749px)');
        this.connection = navigator.connection;
        this.intent = null;
        this.visible = false;
        this.failed = false;
        this.attempt = 0;
        this.video.muted = true;
        this.button.hidden = false;
        this.button.disabled = false;
        const sync = () => this.syncMotion();
        this.button.addEventListener('click', () => {
          this.intent = !(this.wantsMotion() && this.visible && !document.hidden);
          sync();
        }, options);
        this.video.addEventListener('playing', () => {
          if (!this.shouldPlay()) { this.video.pause(); return; }
          this.classList.add('is-playing');
          this.button.textContent = this.button.dataset.pause;
        }, options);
        this.video.addEventListener('pause', () => {
          this.button.textContent = this.button.dataset.play;
        }, options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.intent = false;
          this.classList.remove('is-playing');
          this.button.textContent = this.button.dataset.unavailable;
          this.button.disabled = true;
        }, options);
        document.addEventListener('visibilitychange', sync, options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.intent = false;
          sync();
        }, options);
        this.small.addEventListener('change', sync, options);
        this.connection?.addEventListener('change', sync, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            sync();
          }, { threshold: .1 });
          this.observer.observe(this);
        } else {
          this.visible = true;
          this.intent = false;
        }
      }
      wantsMotion() {
        return this.intent ?? (!this.reduced.matches && !this.connection?.saveData);
      }
      shouldPlay() {
        return this.isConnected && !this.failed && this.wantsMotion() && this.visible && !document.hidden;
      }
      async syncMotion() {
        const attempt = ++this.attempt;
        if (!this.shouldPlay()) { this.video.pause(); return; }
        if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
        try {
          await this.video.play();
          if (!this.shouldPlay()) this.video.pause();
        } catch {
          if (attempt !== this.attempt || !this.shouldPlay()) return;
          this.intent = false;
          this.button.textContent = this.button.dataset.play;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.abort = null;
      }
    });
  }
  if (!customElements.get('mini-mint-coin-total')) {
    customElements.define('mini-mint-coin-total', class extends HTMLElement {
      connectedCallback() {
        const count = Number(this.dataset.total);
        if (!Number.isSafeInteger(count) || count <= 0) return;
        const suffix = this.dataset.suffix === '+' ? '+' : '';
        try {
          this.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 0 }).format(count) + suffix;
        } catch {
          this.textContent = String(count) + suffix;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-mint-treasure-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-mint-treasure')) {
    customElements.define('mini-mint-treasure', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const form = this.querySelector('[data-calculator]');
        const lines = form.querySelector('[data-lines]');
        const template = form.querySelector('[data-line-template]');
        const add = form.querySelector('[data-add]');
        const format = number => new Intl.NumberFormat('en', { maximumFractionDigits: 3 }).format(number);
        const update = () => {
          let total = 0, valid = true;
          const entries = [...lines.children];
          entries.forEach((line, index) => {
            line.querySelector('legend').textContent = 'Treasure line ' + (index + 1);
            const quantity = line.querySelector('[data-quantity]');
            const type = line.querySelector('[data-type]');
            const selected = type.selectedOptions[0];
            const count = quantity.valueAsNumber;
            const ok = quantity.value.trim() !== '' && Number.isInteger(count) && count >= 0 && count <= 1000000;
            quantity.setAttribute('aria-invalid', String(!ok));
            const subtotal = count * Number(selected.dataset.copper);
            line.querySelector('[data-subtotal]').textContent = ok ? format(subtotal / 100) + ' GP' : 'Enter a whole quantity from 0 to 1,000,000.';
            const img = line.querySelector('[data-line-image]');
            img.hidden = !selected.dataset.image;
            img.dataset.gemSize = selected.dataset.gemSize || '';
            if (selected.dataset.image) img.src = selected.dataset.image;
            line.querySelector('[data-remove]').disabled = entries.length === 1;
            line.querySelector('[data-remove]').setAttribute('aria-label', 'Remove treasure line ' + (index + 1));
            valid = valid && ok;
            if(ok) total += subtotal;
          });
          add.disabled = entries.length >= 50;
          form.querySelector('[data-total]').textContent = valid ? format(total / 100) + ' GP' : '—';
          form.querySelector('[data-equivalent]').textContent = valid ? 'Equivalent to ' + format(total) + ' CP = ' + format(total / 10) + ' SP = ' + format(total / 1000) + ' PP.' : '';
          form.querySelector('[data-error]').textContent = valid ? '' : 'Check the highlighted quantities to see your complete total.';
        };
        const addLine = (focus = true) => {
          if(lines.children.length >= 50) return;
          const fragment = template.content.cloneNode(true);
          lines.append(fragment);
          update();
          if(focus) lines.lastElementChild.querySelector('[data-quantity]').focus();
        };
        add.addEventListener('click', () => addLine(), options);
        lines.addEventListener('click', event => {
          const remove = event.target.closest('[data-remove]');
          if(!remove || lines.children.length === 1) return;
          const line = remove.closest('fieldset');
          const next = line.nextElementSibling || line.previousElementSibling;
          line.remove(); update(); next.querySelector('[data-quantity]').focus();
        }, options);
        form.addEventListener('input', update, options);
        form.addEventListener('change', update, options);
        form.addEventListener('submit', event => event.preventDefault(), options);
        form.hidden = false;
        addLine(false);
        const search = this.querySelector('input[type="search"]');
        const rows = [...this.querySelectorAll('[data-gem]')];
        const filter = () => {
          const terms = search.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
          let count = 0;
          rows.forEach(row => { row.hidden = !terms.every(term => row.textContent.toLowerCase().includes(term)); if (!row.hidden) count++; });
          this.querySelector('[data-search-status]').textContent = `${count} of ${rows.length} gem matches shown`;
          this.querySelector('[data-empty]').hidden = count !== 0;
        };
        search.addEventListener('input', filter, options);
        this.querySelector('[data-clear]').addEventListener('click', () => { search.value = ''; filter(); search.focus(); }, options);
        this.querySelector('[data-search-controls]').hidden = false;
        filter();
        const print = this.querySelector('[data-print]');
        print.hidden = false;
        print.addEventListener('click', () => window.print(), options);
        window.addEventListener('beforeprint', () => { rows.forEach(row => row.hidden = false); this.querySelector('[data-empty]').hidden = true; }, options);
        window.addEventListener('afterprint', filter, options);
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-mint-wholesale-dashboard"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-wholesale-order]').forEach((form)=>{const rows=[...form.querySelectorAll('[data-wholesale-row]')];const search=form.querySelector('[data-wholesale-search]');const count=form.querySelector('[data-wholesale-result-count]');const status=form.querySelector('[data-wholesale-status]');const button=form.querySelector('button[type="submit"]');const updateCount=()=>{const visible=rows.filter((row)=>!row.hidden).length;count.textContent=visible===1?form.dataset.countOne:form.dataset.countOther.replace('__count__',String(visible))};search?.addEventListener('input',()=>{const query=search.value.trim().toLowerCase();rows.forEach((row)=>{row.hidden=query!==''&&!row.dataset.searchText.includes(query)});updateCount()});form.querySelectorAll('[data-wholesale-quantity]').forEach((input)=>{input.addEventListener('input',()=>{const value=Number(input.value)||0;const minimum=Number(input.dataset.minimum)||1;const step=Number(input.dataset.step)||1;let message='';if(value>0&&value<minimum)message=input.dataset.minimumMessage;else if(value>0&&(value-minimum)%step!==0)message=input.dataset.stepMessage;input.setCustomValidity(message)})});form.addEventListener('submit',async(event)=>{event.preventDefault();const inputs=[...form.querySelectorAll('[data-wholesale-quantity]:not(:disabled)')];inputs.forEach((input)=>input.dispatchEvent(new Event('input')));const invalid=inputs.find((input)=>!input.checkValidity());if(invalid){invalid.reportValidity();invalid.focus();return}const items=inputs.map((input)=>({id:Number(input.dataset.variantId),quantity:Number(input.value)||0})).filter((item)=>item.quantity>0);if(items.length===0){status.textContent=form.dataset.emptyMessage;return}button.disabled=true;status.textContent='';try{const response=await fetch(form.dataset.cartUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const body=await response.json();if(!response.ok)throw new Error(body.description||body.message||form.dataset.errorMessage);window.location.assign(form.dataset.cartPage)}catch(error){status.textContent=error.message||form.dataset.errorMessage;button.disabled=false}});updateCount()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-mint-workshop"]) return;
  try {
    
if (!customElements.get('mint-workshop-story')) {
  customElements.define('mint-workshop-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.story = this.querySelector('[data-workshop-story]');
      this.stage = this.querySelector('[data-workshop-stage]');
      this.steps = [...this.querySelectorAll('[data-workshop-step]')];
      this.pause = this.querySelector('[data-workshop-pause]');
      this.currentDisplay = this.querySelector('[data-workshop-current]');
      this.progress = this.querySelector('[data-workshop-progress]');
      this.caption = this.querySelector('[data-workshop-caption]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.failedMotion = new Set();
      this.current = 0;
      this.visible = false;
      this.frame = 0;

      if (!this.story || !this.stage || !this.steps.length || !this.pause) return;

      this.pause.closest('label').hidden = false;
      this.pause.addEventListener('change', () => this.updateMotion(), { signal });
      this.reduced.addEventListener('change', () => this.updateMotion(), { signal });
      document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
      addEventListener('scroll', () => this.queueScrollUpdate(), { passive: true, signal });
      addEventListener('resize', () => this.queueScrollUpdate(), { passive: true, signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.steps.indexOf(event.target);
        if (index >= 0) this.select(index);
      }, { signal });
      this.stage.addEventListener('error', () => {
        const step = this.steps[this.current];
        if (this.stage.getAttribute('src') === step.dataset.motion) this.failedMotion.add(step.dataset.motion);
        this.updateMotion();
      }, { signal });

      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.updateMotion();
      }, { threshold: 0.01 });
      this.visibilityObserver.observe(this.story);
      this.select(0, false);
      this.queueScrollUpdate();
    }

    queueScrollUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        const focusLine = innerHeight * 0.62;
        let nearest = 0;
        let distance = Infinity;
        this.steps.forEach((step, index) => {
          const rect = step.getBoundingClientRect();
          const stepDistance = Math.abs((rect.top + rect.bottom) / 2 - focusLine);
          if (stepDistance < distance) {
            distance = stepDistance;
            nearest = index;
          }
        });
        this.select(nearest);
      });
    }

    select(index, transition = true) {
      if (!this.steps[index]) return;
      const changed = index !== this.current;
      this.current = index;
      this.steps.forEach((step, stepIndex) => {
        const active = stepIndex === index;
        step.classList.toggle('is-active', active);
        active ? step.setAttribute('aria-current', 'step') : step.removeAttribute('aria-current');
      });
      const current = this.steps[index];
      this.currentDisplay.textContent = String(index + 1).padStart(2, '0');
      this.progress.style.setProperty('--workshop-progress', `${((index + 1) / this.steps.length) * 100}%`);
      this.caption.textContent = `${this.story.dataset.stepLabel} ${index + 1} of ${this.steps.length}: ${current.dataset.heading}`;
      this.updateMotion();
      if (changed && transition && !this.reduced.matches && this.stage.animate) {
        this.stage.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
      }
      const next = this.steps[index + 1];
      if (next && !this.reduced.matches) {
        const preload = new Image();
        preload.src = next.dataset.still;
      }
    }

    updateMotion() {
      if (!this.stage || !this.steps?.length) return;
      const step = this.steps[this.current];
      const play = this.visible && !this.pause.checked && !this.reduced.matches && !document.hidden && !this.failedMotion.has(step.dataset.motion);
      const source = play ? step.dataset.motion : step.dataset.still;
      if (this.stage.getAttribute('src') !== source) this.stage.setAttribute('src', source);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
